<div class="status-icon" [ngClass]="{'active': value, 'inactive': !value}">
    <div class="col">
        <mat-icon *ngIf="!value" style=" font-size: 15px; width: 15px; height: 15px;" [ngClass]="getStatusIcon()" >radio_button_unchecked</mat-icon>
        <mat-icon *ngIf="value" style=" font-size: 15px; width: 15px; height: 15px;" [ngClass]="getStatusIcon()" >radio_button_checked</mat-icon>
    </div>
</div>